export default {
    body: {
      noMatch: "Nenhum registro encontrado",
      toolTip: "Ordenação",
    },
    pagination: {
      next: "Próxima página",
      previous: "Página anterior",
      rowsPerPage: "Linhas por página:",
      displayRows: "de",
    },
    toolbar: {
      search: "Pesquisar",
      downloadCsv: "Download CSV",
      print: "Impressão",
      viewColumns: "Visualizar colunas",
      filterTable: "Tabela de filtro",
    },
    filter: {
      all: "Todos",
      title: "Filtros",
      reset: "Limpar",
    },
    viewColumns: {
      title: "Mostrar colunas",
      titleAria: "Mostrar/Esconder Colunas de Tabelas",
    },
    selectedRows: {
      text: "Linha(s) selecionada(s)",
      delete: "Apagar",
      deleteAria: "Apagar linhas selecionadas",
    },
  };